import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { RussianReferFriend } from "@/components/RussianReferFriend";
import { SEO } from "@/components/SEO";
import { LocationContext } from "@/lib/locations";

const RussianReferralPage = () => {
  return (
    <LocationContext.Provider value={{ slug: "sacramento-area", name: "Калифорния", type: "region", regionSlug: "sacramento-area" }}>
      <div className="flex min-h-screen flex-col">
        <SEO 
          title="Пригласи друга | Uplevel Cleaning"
          description="Порекомендуйте Uplevel Cleaning другу и оба получите скидку $20 на следующий заказ."
          url="https://uplevelcleaning.com/ru/referral"
          alternateLang="ru"
          includeLocalBusiness={false}
          includeFAQ={false}
        />
        <Navbar />
        <main className="flex-1 pt-24">
          <RussianReferFriend />
        </main>
        <Footer />
      </div>
    </LocationContext.Provider>
  );
};

export default RussianReferralPage;
